import { render, staticRenderFns } from "./FullscreenTextInputC2.vue?vue&type=template&id=27a36319&scoped=true&"
import script from "./FullscreenTextInputC2.vue?vue&type=script&lang=js&"
export * from "./FullscreenTextInputC2.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenTextInputC2.vue?vue&type=style&index=0&id=27a36319&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a36319",
  null
  
)

export default component.exports